import { FC } from "react";
import { removeNbsp } from "../forms/FormBondApp.helpers";
import {
  StyledSidebar,
  StyledSidebarTitle,
  StyledSidebarText,
  StyledSidebarLink,
  StyledPhoneNumber,
} from "./Sidebar.styled";
import { SidebarData } from "../forms/FormBondApp.types";

interface SidebarProps {
  sidebarData: SidebarData;
  bondDescription?: string;
}

export const Sidebar: FC<SidebarProps> = ({ sidebarData, bondDescription }) => {
  const { name, location, phone, description, agencyName, partnershipName } =
    sidebarData;

  const hasMultiName = Array.isArray(name);

  return (
    <StyledSidebar>
      <StyledSidebarTitle>About the bond</StyledSidebarTitle>
      <StyledSidebarText
        fontSize="16px"
        className="mb"
        dangerouslySetInnerHTML={{
          __html: removeNbsp(bondDescription),
        }}
      ></StyledSidebarText>
      <StyledSidebarTitle>Here to help</StyledSidebarTitle>

      <StyledSidebarTitle
        style={{
          fontWeight: 700,
          fontSize: 28,
          lineHeight: "32px",
          color: "var(--accent)",
        }}
      >
        {agencyName ?? name}
      </StyledSidebarTitle>
      {partnershipName && (
        <>
          <StyledSidebarTitle>On Behalf Of</StyledSidebarTitle>
          <StyledSidebarTitle
            style={{
              fontWeight: 700,
              fontSize: 28,
              lineHeight: "32px",
              color: "var(--accent)",
            }}
          >
            {partnershipName}
          </StyledSidebarTitle>
        </>
      )}
      <StyledPhoneNumber>
        {location}
        <StyledPhoneNumber style={{ marginTop: 4 }}>
          <StyledSidebarLink href={`tel:+${phone.replaceAll("-", "")}`}>
            {`+${sidebarData?.phone}`}
          </StyledSidebarLink>
        </StyledPhoneNumber>
      </StyledPhoneNumber>

      <StyledSidebarText fontSize="14px">{description}</StyledSidebarText>
    </StyledSidebar>
  );
};
